import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/real-name",
    name: "real-name",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/IdCardUploader.vue"),
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/already-real-name",
    name: "real-name",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AlreadyRealName.vue"),
    meta: {
      title: "实名认证",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta?.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
